  // Clear the steps
function clear(callback) {
  this.steps = [];
  // this.setState({ created: true });
  if (callback) callback();
  return;
}

export { clear };
